import { BusinessModel, PostingFlows } from 'Douleutaras/types';

export interface ProCardViewedProperties {
  category_slug: string;
  sub_category_slug: string;
  municipality_slug: string;
  county_slug: string;
  positions?: Array<string>;
  pro_ids?: Array<string>;
}

export interface PhoneNumberRevealedProperties {
  category_slug: string;
  sub_category_slug?: string;
  business_unit_slug: string;
  business_model: BusinessModel;
  municipality_slug?: string;
  county_slug?: string;
  job_posting_flow: PostingFlows;
  is_cleaning: boolean;
  is_b2b: boolean;
  is_core: boolean;
  job_id: string;
  bid_id: string;
  pro_id: string;
  customer_id: string;
  source_phone_reveal: PhoneNumberRevealedSource;
}

export interface SuccessModalShownProperties {
  category_slug: string;
  sub_category_slug: string;
  business_unit_slug: string;
  municipality_slug: string;
  county_slug: string;
  is_b2b: boolean;
  is_cleaning: boolean;
  is_core: boolean;
  job_id: number;
  app_source?: string;
  platform: string;
  pro_ids_matched: Array<string>;
  top_pros_matched_count: number;
  new_pros_matched_count: number;
}

export enum SuccessModalAction {
  PROFILE_VISIT = 'profile_visit',
  CHAT = 'chat',
  PHONE = 'phone',
  EXTRA_PRO_FLOW_TRIGGERED = 'extra_pro_flow_triggered',
  CLOSED = 'closed',
  SCROLL = 'scroll'
}

export interface SuccessModalActionProperties extends SuccessModalShownProperties {
  action: SuccessModalAction;
}

export enum PhoneNumberRevealedSource {
  BID_CARD = 'bid_card',
  CHAT = 'chat',
  NEED_HELP = 'need_help',
  EXPRESS_YOUR_INTEREST = 'express_your_interest',
  SUCCESS_MODAL = 'success_modal'
}
